document.addEventListener('DOMContentLoaded', function() {
  const loadMoreBtn = document.querySelector('#load-more-btn');
  const productGrid = document.querySelector('#product-grid');
  let isFetching = false;

  if (!loadMoreBtn || !productGrid) return;

  // Hide the button visually but keep it in the DOM as an anchor for the observer
  loadMoreBtn.style.visibility = 'hidden';
  loadMoreBtn.style.height = '1px';
  loadMoreBtn.style.margin = '0';

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px 400px 0px', // Pre-load 400px before reaching the bottom
    threshold: 0.01
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !isFetching) {
        loadNextPage();
      }
    });
  }, observerOptions);

  observer.observe(loadMoreBtn);

  function loadNextPage() {
    const nextUrl = loadMoreBtn.getAttribute('href');
    if (!nextUrl || nextUrl === '#' || isFetching) return;

    isFetching = true;
    const spinner = document.querySelector('#load-more-spinner');
    if (spinner) spinner.style.display = 'inline-block';

    fetch(nextUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newProducts = html.querySelectorAll('#product-grid .grid__item');
        const newLoadMoreBtn = html.querySelector('#load-more-btn');

        // Append new products to the existing grid
        newProducts.forEach(product => productGrid.appendChild(product));

        // Update the anchor URL for the next page or stop if finished
        if (newLoadMoreBtn) {
          loadMoreBtn.setAttribute('href', newLoadMoreBtn.getAttribute('href'));
          isFetching = false;
        } else {
          observer.unobserve(loadMoreBtn);
          loadMoreBtn.remove();
        }
        
        if (spinner) spinner.style.display = 'none';
      })
      .catch(error => {
        console.error('Infinite scroll error:', error);
        isFetching = false;
      });
  }
});